import { StudentNameDisplayItem, TeacherNameDisplayItem } from '@sb/library/data-models';
import { ItemWithID } from './base.definitions';

export enum ProfileKind {
    Student = "Student",
    Teacher = "Teacher"
}

export class ProfileWithID implements ItemWithID {
    ID!: string;
    Name!: string;
    Active!: boolean;
    Kind!: ProfileKind;
    Item!: StudentNameDisplayItem | TeacherNameDisplayItem;

    constructor(initializer?: Partial<ProfileWithID>) {
        if (initializer) {
            Object.assign(this, initializer);
        }
    }
}

export class ProfilePickerItem<T extends string | StudentNameDisplayItem, U extends string | TeacherNameDisplayItem> {
    Students: T[] = [];
    Teachers: U[] = [];

    constructor(initializer?: Partial<ProfilePickerItem<T, U>>) {
        if (initializer) {
            Object.assign(this, initializer);
        }
    }
}
